import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MdMenu } from "react-icons/md";
import toast, { Toaster } from "react-hot-toast";
import profile2 from "../../assets/profile.svg";
import { getAdminProfile } from "../../api/apiServices";

export default function Header({ setIsOpen }) {
  const location = useLocation();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const pageName =
    location.pathname.split("/").filter(Boolean).pop() || "Dashboard";

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const admin = await getAdminProfile();
        setProfile(admin.user);
      } catch (err) {
        console.error("Error fetching profile:", err);
        toast.error("Failed to load profile");
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  return (
    <div className="fixed top-0 left-0 lg:left-[280px] right-0 z-40 bg-white px-4 md:px-6 flex items-center justify-between border-b border-gray-200 h-[72px]">
      <Toaster position="top-right" reverseOrder={false} />

      {/* Left: hamburger (mobile only) + page title */}
      <div className="flex items-center gap-3">
        <button
          className="lg:hidden p-2 -ml-2 text-gray-600 hover:text-orange-500 transition-colors"
          onClick={() => setIsOpen(true)}
          aria-label="Open menu"
        >
          <MdMenu size={26} />
        </button>
        <p className="text-sm font-semibold text-gray-700 capitalize">
          {pageName}
        </p>
      </div>

      {/* Right: profile */}
      <div className="flex items-center space-x-3">
        {loading ? (
          <>
            <div className="h-9 w-9 rounded-full bg-gray-200 animate-pulse" />
            <div className="hidden sm:block">
              <div className="w-20 h-3 bg-gray-200 rounded mb-1 animate-pulse" />
              <div className="w-14 h-2 bg-gray-200 rounded animate-pulse" />
            </div>
          </>
        ) : profile ? (
          <>
            <div className="h-9 w-9 rounded-full overflow-hidden border border-gray-300 shrink-0">
              <img
                src={profile.image || profile2}
                alt="profile"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="text-left hidden sm:block">
              <h1 className="text-sm font-semibold text-gray-800">{profile.email}</h1>
              <p className="text-xs text-gray-500">{profile.role}</p>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}
